import { z } from 'zod'
import { dealStageSchema } from './deals.ts'

export const DEAL_BOARD_SORTS = [
  'manual',
  'created',
  'amount',
  'next_action',
  'expected_close',
  'name_asc',
  'name_desc',
] as const
export const DEAL_BOARD_DENSITIES = ['comfortable', 'compact'] as const

export const dealBoardViewSchema = z.strictObject({
  hiddenStages: z.array(dealStageSchema).default([]),
  onlyMine: z.boolean().default(false),
  showLost: z.boolean().default(false),
  sort: z.enum(DEAL_BOARD_SORTS).default('manual'),
  density: z.enum(DEAL_BOARD_DENSITIES).default('comfortable'),
  visibleCardFields: z.array(z.string()).default([]),
})

export type DealBoardView = z.infer<typeof dealBoardViewSchema>

export const DEFAULT_DEAL_BOARD_VIEW: DealBoardView = {
  hiddenStages: [],
  onlyMine: false,
  showLost: false,
  sort: 'manual',
  density: 'comfortable',
  visibleCardFields: [],
}
